import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import makeRequest from './makeRequest';
import getEvertransitAccessToken from './getEvertransitAccessToken';
import getUserIdToken from './getUserIdToken';
import removeFirebaseCookieToken from './removeFirebaseCookieToken';
var url = "".concat(process.env.REACT_APP_BASE_URL, "/auth/logout");

var logout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(app) {
    var dashrideToken, firebaseToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            removeFirebaseCookieToken();
            dashrideToken = getEvertransitAccessToken();
            _context.next = 5;
            return getUserIdToken(app);

          case 5:
            firebaseToken = _context.sent;

            if (!dashrideToken) {
              _context.next = 9;
              break;
            }

            _context.next = 9;
            return makeRequest({
              url: url,
              method: 'POST',
              data: {
                token: dashrideToken
              }
            }, firebaseToken);

          case 9:
            app.auth().signOut();
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0); // eslint-disable-next-line no-console

            console.error(_context.t0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function logout(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default logout;